<template>
  <page
    :custom-style="{
      height: '100vh',
      backgroundColor: '#f5f5f5'
    }"
  >
    <div class="wrapper">
      <div class="wrapper-container">
        <h3>
          {{ couponPackDetail.activityName }}({{
            couponPackDetail.couponNums
          }}张)
        </h3>
        <div class="limit">
          <div class="limit-desc">
            {{ couponPackDetail.subTitle }}
          </div>
          <div class="limit-progress">
            <div class="progress-wrapper">
              <div class="progress" :style="{ width: progress + '%' }" />
              <div
                v-if="progress > 39"
                class="progress-desc"
                :style="{ width: progress + '%' }"
              >
                &nbsp;{{ progress }}%
              </div>
              <div
                v-else
                class="progress-desc progress-desc-left"
                :style="{ left: progress + '%' }"
              >
                &nbsp;{{ progress }}%
              </div>
            </div>
          </div>
        </div>
        <div class="limit-time">
          {{ couponPackDetail.timeSubTitle }}
        </div>

        <div class="coupon-list">
          <coupon
            v-for="(item, index) in couponList"
            :key="index"
            :detail="item"
          />
        </div>
      </div>
      <div class="btn-wrap">
        <div class="agreement">
          <div class="checkbox" :class="{ checked: checkbox }">
            <span v-if="checkbox" class="" />
            <input v-model="checkbox" type="checkbox" />
          </div>
          <div class="agreement-desc">
            已阅读并同意<span class="agr-link" @click="goViewAgreement"
              >《券包服务协议》</span
            >
          </div>
        </div>
        <div v-if="status.type === 1" class="btn" @click="handleBuyCouponPack">
          <div class="price-wrapper">
            <span class="new-price">¥{{ price.sellPrice }}</span>
            <span>购买</span>
            <span class="origin-price"
              ><span class="slash">/</span
              ><span class="price">原价¥{{ price.originPrice }}</span></span
            >
          </div>
        </div>
        <div v-if="status.type === 3" class="btn sold-out">
          {{ status.typeName }}
        </div>
        <div v-if="status.type === 2" class="btn will-sold">
          <span>距开始还剩</span>
          <count-down
            size="large"
            :time="status.leftTime"
            @down="handleCountDown"
          />
        </div>
      </div>
    </div>
  </page>
</template>
<script>
import Coupon from './components/Coupon.vue'
import CountDown from './components/CountDown.vue'
import { mallDomain } from '@/defines/domains'
import { API } from '@/api'
import { navBar } from '@/utils/native_interactions/native_bar'
import Url from '@mc/mc-utils/js/url/url'
import { Bridge } from '@mc/mc-jsbridge'
import { nativeRedirect } from '@/utils/native_interactions/native_redirect'
import { nativeRoutes } from '@/utils/native_interactions/native_redirect/routes'
export default {
  name: 'CouponDetail',
  components: {
    Coupon,
    CountDown
  },
  beforeRouteEnter(to, from, next) {
    next(v => {
      navBar.setTitle({
        text: '省钱券包'
      })
      Bridge.call('navigatePageSetting', { edgeInsets: { edge: 0 } })
      v.getCouponPackDetail()
    })
  },
  data() {
    return {
      couponPackDetail: {},
      couponList: [],
      checkbox: true,
      agreementUrl: '',
      submitIng: false
    }
  },
  computed: {
    progress() {
      return this.couponPackDetail.percent || 0
    },
    price() {
      return this.couponPackDetail.price
    },
    status() {
      const status = this.couponPackDetail.status
      let typeName = ''
      let leftTime = ''
      let type = ''
      switch (status) {
        case 1: // 可购买
          type = 1
          break
        case 6: // 未开始
          type = 2
          leftTime = this.couponPackDetail.leftTime
          break
        case 2: // 已购买
          type = 3
          typeName = '已购买'
          break
        case 3: // 已售罄
          type = 3
          typeName = '已售罄'
          break
      }
      return {
        typeName,
        type,
        leftTime
      }
    }
  },
  mounted() {
    document.addEventListener('visibilitychange', this.pageShow)
  },
  created() {
    this.submitIng = false
  },
  methods: {
    pageShow() {
      if (!document.hidden) {
        this.getCouponPackDetail()
      }
    },
    goBack() {
      this.$back()
    },
    goViewAgreement() {
      this.$autoRedirect(this.agreementUrl)
    },
    handleBuyCouponPack() {
      if (this.submitIng) return
      this.submitIng = true
      if (!this.checkbox) {
        this.$dialog.alert({
          title: '温馨提示',
          message: '请确认勾选付费券包购买协议'
        })
        return
      }
      this.$track(this.$trackMap.memberCouponpack.btn_go_pay)
      const successUrl = `${mallDomain}/marketing/#/member-couponpack-success`
      // const payUrl = `${mallDomain}/marketing/#/member-couponpack-history`

      API.memberCouponPack
        .getCouponPackPayUrl({
          activityId: this.$route.query.id,
          successUrl,
          backUrl: '',
          activityName: this.couponPackDetail.activityName,
          actionId: this.couponPackDetail.actionId
        })
        .then(res => {
          nativeRedirect(nativeRoutes.cashier, {
            paySecret: encodeURIComponent(res.paySecret),
            agentId: res.agentId,
            successUrl,
            urlEncode: 1
          })
        })
        .catch(e => {
          this.$dialog
            .alert({
              title: '温馨提示',
              message: e.error.msg
            })
            .then(() => {
              this.goBack()
              this.submitIng = false
            })
        })
    },
    handleCountDown() {
      this.couponPackDetail.status = 1
    },
    getCouponPackDetail() {
      this.submitIng = false
      const url = new Url(window.location.href)
      const query = url.parseQuerystring()
      const hashQuery = url.Hash ? url.Hash.parseQuerystring() : {}
      const activityId = query.id || hashQuery.id || ''
      API.memberCouponPack
        .getCouponPackDetail({ activityId })
        .then(res => {
          this.couponList = res.couponList
          this.couponPackDetail = res.couponPackDetail
          this.agreementUrl = res.agreementUrl
        })
        .catch(e => {
          this.$catch(e)
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
  .wrapper-container {
    padding: 0.5rem 0.32rem 0;
    box-sizing: border-box;
    flex: 1;
    overflow-y: auto;
  }
}
.limit {
  margin: 0.2rem 0;
  display: flex;
  &-desc {
    padding: 0 0.1rem;
    height: 0.32rem;
    line-height: 0.32rem;
    text-align: center;
    border-radius: 0.28rem;
    border: 1px solid rgba(255, 74, 40, 0.5);
    box-sizing: border-box;
    color: rgb(255, 74, 40);
    font-size: 0.2rem;
  }
  &-progress {
    flex: 1;
    display: flex;
    align-items: center;
    margin-left: 0.2rem;
  }
}
.limit-time {
  margin-bottom: 0.28rem;
  font-size: 0.28rem;
  color: #999;
}
.progress-wrapper {
  position: relative;
  background-color: #ececec;
  border-radius: 6px;
  width: 100%;
  height: 0.24rem;
  line-height: 0.24rem;
  .progress {
    background-image: linear-gradient(to right, #ff7d5e 0%, #ff3410 100%);
    border-radius: 6px;
    height: 100%;
  }
  .progress-desc {
    position: absolute;
    top: 0;
    color: #fff;
    font-size: 0.2rem;
    text-align: center;
    &.progress-desc-left {
      color: #666;
      margin-left: 0.1rem;
    }
  }
}

.prompt {
  padding: 0.22rem 0 0.5rem;
  font-size: 0.24rem;
  line-height: 0.38rem;
  h3 {
    color: #333;
    font-weight: 400;
  }
  p {
    color: rgba(51, 51, 51, 0.3);
  }
}
.btn-wrap {
  height: 1.8rem;
  .agreement {
    height: 0.72rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f6f6f6;
    .checkbox {
      margin-right: 0.1rem;
      position: relative;
      width: 0.28rem;
      height: 0.28rem;
      border-radius: 0.04rem;
      background-image: url('~@/images/couponPack/unselected@3x.png');
      background-size: 100%;
      &.checked {
        background-image: url('~@/images/couponPack/selected@3x.png');
      }
      input {
        position: absolute;
        top: 0;
        width: 100%;
        height: 100%;
      }
    }
    .agreement-desc {
      font-size: 0.24rem;
      color: #999;
      .agr-link {
        color: #ff4a28;
      }
    }
    input {
      width: 10px;
      height: 10px;
    }
  }
  .btn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 1.08rem;
    background: linear-gradient(to right, #ff7d5e 0%, #ff3410 100%);
    color: #fff;
    .price-wrapper {
      font-size: 0.4rem;
      .new-price {
        font-size: 0.44rem;
      }
      .origin-price {
        font-size: 0.24rem;
        .price {
          text-decoration: line-through;
        }
        .slash {
          padding-right: 0.1rem;
        }
      }
    }
    &.sold-out {
      background: #bfbfbf;
    }
    &.will-sold {
      & > span {
        margin-right: 0.2rem;
        font-size: 0.3rem;
        font-weight: 400;
      }
    }
  }
}
</style>
